/* eslint-disable prettier/prettier */
export function convertMapBoxFeature(feature) {
    const {
      id: apiId,
      text: shortName,
      place_name: longName,
      place_type: placeType,
      geometry: geometry,
      properties: properties
    } = feature;
    /* Manage case when a feature has more than one placetype */
    /* Example Paris is a region and place for Mapbox */
    const indexOfRegion = placeType.indexOf("region");
    indexOfRegion !== -1 ? placeType.splice(indexOfRegion, 1) : 0;
    return {
      properties: {
        apiId,
        shortName,
        longName,
        category: properties.category,
        placeType: placeType[0],
        wikibase: properties.wikidata
      },
      geometry
    };
}
export function convertGemmiciLocation( location ){
    const {
        geometry: geometry,
        properties: properties
      } = location;
    return {
        properties: {
            apiId: properties.apiId,
            shortName: properties.shortName,
            longName: properties.longName,
            placeType: properties.placeType,
            wikibase: properties.wikibase,
            category: properties.category
        },
        geometry
      }
}